<template>
<div>
    <div class="" v-if="maxRoundNo > 1 && currTab === 'comparison'" style="right: 8px;z-index: 1;position: absolute;">
        <el-form :inline="true" size="small">
            <!-- 选择轮次 -->
            <el-form-item label="选择轮次:">
                <el-select v-model="roundNo" placeholder="请选择" size="small" @change="changeRoundNo($event)">
                    <el-option v-for="index of maxRoundNo" :key="index" :label="index" :value="index"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
     </div>
    <el-tabs @tab-click="handleCheckTabClick" v-model="currTab" v-if="partList.length">
        <el-tab-pane :key="1" label="汇总表" name="summary">
            <div style="margin-left:20px;">
                显示数据图表: <el-switch v-model="mainChartsVisible" @change="handleMainChange"></el-switch>
                <!-- 显示数据表格: <el-switch v-model="comparTablevisiable"></el-switch> -->
            </div>
            <div id="summaryCharts" style="width: 100%;height:400px;" v-show="mainChartsVisible"></div>
            <div>
                <span class="mt20">轮次对比表:</span>
                <el-table :data="allSummaryList" :header-cell-style="{background:'#f5f5f5'}" size="mini" border stripe max-height="380px" class="mt10">
                    <el-table-column prop="roundNo" header-align="center" align="left" label="报价轮次" width="150" />
                    <el-table-column prop="" header-align="center" align="left" label="技术通知编码" width="150">
                        {{basicFormData.technicalCode}}
                    </el-table-column>
                    <el-table-column prop="" header-align="center" align="left" label="任务名称" width="150">
                        {{basicFormData.taskName}}
                    </el-table-column>

                    <el-table-column v-for="sName in supplierColNames" :key="sName" :prop="sName" header-align="center" align="right" :label="sName" width="150">
                        <template slot-scope="scope">
                            <div :class="scope.row[sName + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row[sName]) }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价" width="150" />

                </el-table>

                <!-- 比价表 -->
                <!-- 需要零件和供应商的关系 -->
                <!-- 按供应商ID求和 -->
                <!-- checkbox加上去 -->
                <!-- 最低价格涂绿色：到底哪一项最低 -->
                <span class="mt20">当前轮次对比:</span>
                <el-table v-if="true" :data="summaryList" :header-cell-style="{background:'#f5f5f5'}" size="mini" border stripe max-height="380px" @selection-change="selectionSummaryChange" class="mt10">
                    <!-- <el-table-column type="selection" width="55">
                    </el-table-column> -->

                    <!-- <el-table-column type="index" width="50" label="序号">
                    </el-table-column> -->
                    <el-table-column prop="rfqSupplierCode" header-align="center" align="left" label="供应商编号" width="150">
                    </el-table-column>
                    <el-table-column prop="rfqSupplierName" header-align="center" align="left" label="供应商名称" width="200">
                    </el-table-column>
                    <el-table-column prop="ip" header-align="center" align="left" label="报价IP" width="200">
                    </el-table-column>
                    <el-table-column prop="targetPrice" header-align="center" align="left" label="目标价格" width="120">
                    </el-table-column>
                    <el-table-column prop="materialCost" header-align="center" align="left" label="原材料" width="150">
                        <template slot-scope="scope">
                            <div :class="scope.row.materialCostMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.materialCost) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="materialImportCost" header-align="center" align="left" label="进口原材料" width="150">
                        <template slot-scope="scope">
                            <div :class="scope.row.materialImportCostMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.materialImportCost) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="outsidePartCost" header-align="center" align="left" label="外购零部件" width="150">
                        <template slot-scope="scope">
                            <div :class="scope.row.outsidePartCostMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.outsidePartCost) }}
                            </div>
                        </template>

                    </el-table-column>
                    <el-table-column prop="importOutsidePartCost" header-align="center" align="left" label="进口外购零部件" width="150">
                        <template slot-scope="scope">
                            <div :class="scope.row.importOutsidePartCostMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.importOutsidePartCost) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="processingCost" header-align="center" align="right" label="加工费" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row.processingCostMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.processingCost) }}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="partName" header-align="center" align="left" label="单车用量(RMB)">
                        </el-table-column> -->
                    <el-table-column prop="productionCostSum" header-align="center" align="right" label="制造成本小计" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row.productionCostSumMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.productionCostSum) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="managementCost" header-align="center" align="right" label="管理费用" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row.managementCostMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.managementCost) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleCost" header-align="center" align="right" label="销售费用" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row.saleCostMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.saleCost) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accountCost" header-align="center" align="right" label="财务费用" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row.accountCostMinFlag ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.accountCost) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="midiumCostSum" header-align="center" align="right" label="期间费用小计" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['midiumCostSum' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.midiumCostSum) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="profit" header-align="center" align="right" label="利润" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['profit' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.profit) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productUnitPrice" header-align="center" align="right" label="产品单价" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['productUnitPrice' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.productUnitPrice) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="packageFee" header-align="center" align="right" label="包装费" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['packageFee' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.packageFee) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="transportFee" header-align="center" align="right" label="运输费" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['transportFee' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.transportFee) }}
                            </div>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="toolsTotalInvestment" header-align="center" align="right" label="模具总投资额" width="110">
                        <template slot-scope="scope">
                            <div :class="scope.row['toolsTotalInvestment' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.toolsTotalInvestment) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="toolsPartAllocation" header-align="center" align="right" label="模具分摊单价" width="110">
                        <template slot-scope="scope">
                            <div :class="scope.row['toolsPartAllocation' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.toolsPartAllocation) }}
                            </div>
                        </template>
                    </el-table-column>
                                    <el-table-column prop="designTotalInvestment" header-align="center" align="right" label="实验总投资额" width="110">
                        <template slot-scope="scope">
                            <div :class="scope.row['designTotalInvestment' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.designTotalInvestment) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="designPartAllocation" header-align="center" align="right" label="实验分摊单价" width="110">
                        <template slot-scope="scope">
                            <div :class="scope.row['designPartAllocation' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.designPartAllocation) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="feeCostSum" header-align="center" align="right" label="合计" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['feeCostSum' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.feeCostSum) }}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="totalInvest" header-align="center" align="right" label="总投资额" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['totalInvest' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.totalInvest) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amortizationMoney" header-align="center" align="right" label="分摊" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['amortizationMoney' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.amortizationMoney) }}
                            </div>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="totalCost" header-align="center" align="right" label="总计(不含税)" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['totalCost' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.totalCost) }}
                            </div>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="taxCost" header-align="center" align="right" label="增值税" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['taxCost' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.taxCost) }}
                            </div>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="salePriceCost" header-align="center" align="right" label="销售价格(含税)" width="120">
                        <template slot-scope="scope">
                            <div :class="scope.row['salePriceCost' + 'MinFlag'] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row.salePriceCost) }}
                            </div>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
        </el-tab-pane>
        <el-tab-pane :key="2" label="对比表" name="comparison">
            <!-- 零件与供应商 -->
            <!-- 零件编码: {{currentPartCode}} 零件名称: {{currentPartName}} 进度: {{currentPartIndex}}/{{currentPartCount}}
            <div style="float:right">

                <el-button size="mini" :disabled="currentPartIndex === 1" @click="prious">上一个</el-button>
                <el-button size="mini">选择</el-button>
                <el-button size="mini" :disabled="currentPartIndex === currentPartCount" @click="next">下一个</el-button>
            </div> -->
            <!-- 供应商和零件关联报价 -->
            <!-- 按零件求和 -->
            <!-- checkbox加上去 -->
            <!-- <div id="xxxttt" style="width: 600px;height:400px;"></div> -->
            <div>
                <template v-if="basicFormData.roundNo > 1">
                    选择轮次:
                    <el-select v-model="this.currRound" placeholder="请选择轮次" size="mini" @change="handleRoundChange($event)">
                        <el-option v-for="item in roundList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </template>
                <el-table :data="partCompareList" :header-cell-style="{background:'#f5f5f5'}" style="width: 100%" border stripe size="mini">
                    <el-table-column prop="partName" label="零件名" width="" header-align="center" />
                    <el-table-column v-for="supp in currentSupplierList" :key="supp.id" :prop="supp.id" :label="supp.name" header-align="center" align="right">
                        <template slot-scope="scope">
                            <div :class="scope.row['minPrice'] === scope.row[supp.id] ? 'min-price' : ''">
                                {{ fixedNumber(scope.row[supp.id]) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="targetPrice" label="目标价格" width="" header-align="center" align="right" />
                    <el-table-column prop="oneCarCount" label="单车用量" width="" header-align="center" align="right" />
                </el-table>
            </div>
            <div style="margin-left:20px;">
                显示数据图表: <el-switch v-model="compareChartsVisible" @change="handleChange"></el-switch>
                <!-- 显示数据表格: <el-switch v-model="comparTablevisiable"></el-switch> -->
            </div>
            <div style="padding:10px 20px 10px 20px">
                <el-card v-for="(part,index) in pm.partList" :key="index" class="mb15">
                    <!-- <div id="xxxttt" style="width: 600px;height:400px;"></div> -->
                    <div slot="header">
                        <span>零件名称: {{part.name}}</span>
                        <span class="ml10">零件号: {{part.code}}</span>
                        <span class="ml10">单车用量: {{part.oneCarCount}}</span>
                        <span class="ml10">目标价格: {{part.targetPrice}}</span>
                        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                    </div>
                    <div :id="part.id + 'charts'" style="width: 100%;height:200px;" v-show="compareChartsVisible"></div>
                    <div>
                        <el-table :data="part.suppliers" :header-cell-style="{background:'#f5f5f5'}" style="width: 100%" border stripe size="mini" v-if="comparTablevisiable">
                            <el-table-column prop="rfqSupplierName" label="供应商名称" width="200" />
                            <el-table-column prop="ip" label="报价IP" width="200" />
                            <!-- <el-table-column prop="salePriceCost" label="总价(含税)" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.salePriceCostMin === scope.row.salePriceCost ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.salePriceCost)}}
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column prop="feeCostSum" label="合计" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.feeCostSum === scope.row.feeCostSum ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.feeCostSum)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="materialCost" label="原材料A" width="" >
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.materialCostMin === scope.row.materialCost ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.materialCost)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="materialImportCost" label="进口原材料" width="" /> -->
                            <el-table-column prop="outsidePartCost" label="外购零部件B" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.outsidePartCostMin === scope.row.outsidePartCost ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.outsidePartCost)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="importOutsidePartCost" label="进口外购零部件" width="" /> -->
                            <el-table-column prop="processingCost" label="加工费C" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.processingCostMin === scope.row.processingCost ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.processingCost)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="productionCostSum" label="制造成本小计D" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.productionCostSumMin === scope.row.productionCostSum ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.productionCostSum)}}
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="managementCost" label="管理费用E" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.managementCostMin === scope.row.managementCost ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.managementCost)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="saleCost" label="销售费用F" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.saleCostMin === scope.row.saleCost ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.saleCost)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="accountCost" label="财务费用G" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.accountCostMin === scope.row.accountCost ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.accountCost)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="accountCost" label="期间费用小计H" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.midiumCostSumMin === scope.row.midiumCostSum ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.midiumCostSum)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="profit" label="利润I" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.profitMin === scope.row.profit ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.profit)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="toolsPartAllocation" label="模具开发摊销M" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.toolsPartAllocation === scope.row.toolsPartAllocation ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.toolsPartAllocation)}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="designPartAllocation" label="试验设计摊销N" width="">
                                <template slot-scope="scope">
                                    <div :class="part.minPartPrice.designPartAllocation === scope.row.designPartAllocation ? 'min-price' : ''">
                                        {{fixedNumber(scope.row.designPartAllocation)}}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </div>
            <el-table v-if="false" :data="priceList" :header-cell-style="{background:'#f5f5f5'}" size="mini" highlight-current-row border stripe max-height="380px" @selection-change="selectionPartChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column type="index" width="50" label="序号">
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="零件编码" width="150">
                </el-table-column>
                <el-table-column prop="partName" header-align="center" align="left" label="零件名称" width="150">
                </el-table-column>
                <el-table-column prop="rfqSupplierCode" header-align="center" align="left" label="供应商编号" width="150">
                </el-table-column>
                <el-table-column prop="rfqSupplierName" header-align="center" align="left" label="供应商名称" width="150">
                </el-table-column>
                <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.targetPrice)}}
                    </template>
                </el-table-column>

                <el-table-column prop="materialCost" header-align="center" align="left" label="原材料" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.materialCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="materialImportCost" header-align="center" align="left" label="进口原材料" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.materialImportCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="outsidePartCost" header-align="center" align="left" label="外购零部件" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.outsidePartCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="importOutsidePartCost" header-align="center" align="left" label="进口外购零部件" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.importOutsidePartCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="processingCost" header-align="center" align="right" label="加工费" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.processingCost)}}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="partName" header-align="center" align="left" label="单车用量(RMB)">
                        </el-table-column> -->
                <el-table-column prop="productionCostSum" header-align="center" align="right" label="制造成本小计" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.productionCostSum)}}
                    </template>
                </el-table-column>
                <el-table-column prop="managementCost" header-align="center" align="right" label="管理费用" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.managementCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="saleCost" header-align="center" align="right" label="销售费用" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.saleCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="accountCost" header-align="center" align="right" label="财务费用" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.accountCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="midiumCostSum" header-align="center" align="right" label="期间费用小计" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.midiumCostSum)}}
                    </template>
                </el-table-column>
                <el-table-column prop="profit" header-align="center" align="right" label="利润" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.profit)}}
                    </template>
                </el-table-column>
                <el-table-column prop="productUnitPrice" header-align="center" align="right" label="产品单价" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.productUnitPrice)}}
                    </template>
                </el-table-column>
                <el-table-column prop="packageFee" header-align="center" align="right" label="包装费" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.packageFee)}}
                    </template>
                </el-table-column>
                <el-table-column prop="transportFee" header-align="center" align="right" label="运输费" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.transportFee)}}
                    </template>
                </el-table-column>
                <el-table-column prop="feeCostSum" header-align="center" align="right" label="费用合计" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.feeCostSum)}}
                    </template>
                </el-table-column>
                <el-table-column prop="totalInvest" header-align="center" align="right" label="总投资额" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.totalInvest)}}
                    </template>
                </el-table-column>
                <el-table-column prop="amortizationMoney" header-align="center" align="right" label="分摊" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.amortizationMoney)}}
                    </template>
                </el-table-column>
                <el-table-column prop="totalCost" header-align="center" align="right" label="总计(不含税)" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.totalCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="taxCost" header-align="center" align="right" label="增值税" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.taxCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="salePriceCost" header-align="center" align="right" label="销售价格(含税)" width="120">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.salePriceCost)}}
                    </template>
                </el-table-column>
            </el-table>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import {
    getRfqPartViewList,
    getSupplierSummaryList,
    queryCurrentRoundAndLastList,
    listPartCompare
} from '@/controller/rfq'
import {
    RFQ_STATUS,
    USER_TYPE,
    QUOTATION_STATUS,
    getQUOTATION_STATUS_VALUE,
} from '@/utils/const'
import moment from 'moment'
import partmodel from './model/partmodel'
import PartItem from './model/partviewitem'
import * as echarts from 'echarts'
// require('@/mock/mockQuotation');
export default {
    props: {
        //供应商列表数据
        basicFormData: Object,
        supplierList: Array,
        viewFlag: Boolean,
        partList: Array,

    },
    data() {
        return {
            currTab: 'summary',
            RFQ_STATUS: RFQ_STATUS,
            QUOTATION_STATUS: QUOTATION_STATUS,
            QUOTATION_STATUS_VALUE: getQUOTATION_STATUS_VALUE,
            priceList: [],
            summaryList: [],
            selectSummaryData: [],
            selectPartData: [],
            flowableType: '', //TODO:
            USER_TYPE: USER_TYPE,
            currentPartCode: '',
            currentPartName: '',
            currentPartIndex: 0,
            currentPartCount: 0,
            roundNo: 1,
            flowParam: {
                flowTaskId: '',
                paramKey: '',
                paramVal: ''
            },
            dataRule: {
                // name: [{
                //     required: true,
                //     message: '组织名称不能为空',
                //     trigger: 'blur'
                // }],
                // code: [{
                //     required: true,
                //     message: '组织代码不能为空',
                //     trigger: 'blur'
                // }],
                // tenantName: [{
                //     required: true,
                //     message: '请先在页面顶部导航栏选择租户',
                //     trigger: 'blur'
                // }]
            },
            pm: new partmodel(),
            mainChartsVisible: false,
            compareChartsVisible: false,
            comparTablevisiable: true,
            dataInitd: false,
            allSummaryList: [],
            allSupplierList: [],
            supplierColNames: [],
            partCompareList: [],
            currentSupplierList: [],
            currRound: 0,
            maxRoundNo:1,
        }
    },
    computed: {
        roundList() {
            if (!this.basicFormData) return []
            debugger
            const arr = []
            const currRound = maxRoundNo
            for (let i = 1; i <= currRound; i++) {
                arr.push({
                    label: `第${i}轮`,
                    value: i,
                })
            }
            return arr
        }
    },

    mounted() {
        // this.xx()
        debugger
        if(this.basicFormData.rfqStatus == '2' && this.basicFormData.times > 1) {
            this.roundNo = this.basicFormData.times - 1
            this.maxRoundNo = this.basicFormData.times - 1
        } else {
            this.roundNo = this.basicFormData.times
            this.maxRoundNo = this.basicFormData.times
        }
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        initEcharts(data) {
            const options = this.pm.getPartEchartsOption(data)
            const myChart = echarts.init(document.getElementById(data.id + 'charts'));
            myChart.setOption(options)
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // 查所有供应商表
        async getPriceList(id) {
            // this.priceList = []
            try {
                const params = {
                    rfqId: id,
                    roundNo: this.roundNo
                }
                const data = await getRfqPartViewList(params)
                if (data && data.code === "00") {
                    this.priceList = data.body
                    this.currentPartIndex = 1
                    this.currentPartCount = this.priceList.length

                    const pm = new partmodel()
                    pm.parts = this.priceList.map(v => new PartItem().init(v))
                    pm.initData()
                    this.pm = pm
                } else {
                    this.priceList = [];
                    this.currentPartIndex = 0
                    this.currentPartCount = this.priceList.length
                }
            } catch {

            } finally {

            }
        },
        async getSupplierSummaryList(id) {
            try {
                const parmas = {
                    rfqId: id,
                    roundNo: this.roundNo // this.roundNo
                }
                debugger
                const data = await queryCurrentRoundAndLastList(parmas)
                if (data && data.code === "00") {
                    const arr = data.body;
                    debugger
                    const minMap = new Map()

                    const numericKeys = [
                        'targetPrice',
                        'materialCost',
                        'materialImportCost',
                        'outsidePartCost',
                        'importOutsidePartCost',
                        'processingCost',
                        'productionCostSum',
                        'managementCost',
                        'saleCost',
                        'accountCost',
                        'midiumCostSum',
                        'profit',
                        'productUnitPrice',
                        'packageFee',
                        'transportFee',
                        'feeCostSum',
                        'totalInvest',
                        'amortizationMoney',
                        'totalCost',
                        'taxCost',
                        'salePriceCost',
                        'toolsTotalInvestment',
                        'toolsPartAllocation',
                        'designTotalInvestment',
                        'designPartAllocation',
                    ]

                    numericKeys.forEach(v => {
                        const value = {
                            min: null,
                            indexList: [],
                        }
                        minMap.set(v, value)
                    })

                    for (let i = 0; i < arr.length; i++) {
                        const item = arr[i]
                        minMap.forEach((data, key) => {
                            if (i === 0) {
                                data.min = item[key]
                                data.indexList = [0]
                            } else {
                                if (item[key] < data.min) {
                                    data.min = item[key]
                                    data.indexList = [i]
                                } else if (item[key] === data.min) {
                                    data.indexList.push(i)
                                }
                            }
                        })
                    }

                    for (let i = 0; i < arr.length; i++) {
                        const item = arr[i]
                        minMap.forEach((data, key) => {
                            if (data.indexList.includes(i)) {
                                item[key + 'MinFlag'] = true
                            }
                        })
                    }

                    console.log(arr)
                    debugger
                    this.summaryList = arr
                } else {
                    this.summaryList = [];
                }
            } catch (e) {

            } finally {

            }
        },
        handleSummaryMin() {

        },
        async getAllSummartList(id) {
            try {
                const parmas = {
                    rfqId: id,
                }
                const data = await getSupplierSummaryList(parmas)
                if (data && data.code === "00") {
                    const arr = data.body;
                    debugger
                    const roundSet = new Set()
                    const rfqSupplierUniq = new Set()
                    arr.forEach(v => {
                        if (v.roundNo !== null && !roundSet.has(v.roundNo)) {
                            roundSet.add(v.roundNo)
                        }
                        if (!rfqSupplierUniq.has(v.rfqSupplierName)) {
                            rfqSupplierUniq.add(v.rfqSupplierName)
                        }
                    })

                    const roundList = [...roundSet.values()].sort((a, b) => a - b).map(v => {
                        return {
                            roundNo: v,
                        }
                    })

                    const supplierColNames = [...rfqSupplierUniq.values()]

                    arr.forEach(v => {
                        const rItem = roundList.find(t => t.roundNo === v.roundNo)
                        if (rItem) {
                            rItem[v.rfqSupplierName] = v.feeCostSum

                            if (!rItem.hasOwnProperty('targetPrice')) {
                                rItem['targetPrice'] = v.targetPrice
                            }
                        }
                    })

                    roundList.forEach(v => {
                        let minColNames = []
                        for (let key in v) {
                            if (rfqSupplierUniq.has(key)) {
                                if (minColNames.length === 0) {
                                    minColNames = [key]
                                } else if (v[minColNames[0]] === v[key]) {
                                    minColNames.push(key)
                                } else if (v[minColNames[0]] > v[key]) {
                                    minColNames = [key]
                                }
                            }
                        }
                        // console.log(rfqSupplierUniq)
                        // console.log(minColNames)
                        // debugger
                        minColNames.forEach(n => {
                            v[n + 'MinFlag'] = true
                        })
                    })
                    this.supplierColNames = supplierColNames
                    this.allSummaryList = roundList
                } else {
                    this.allSummaryList = [];
                }
            } catch (e) {} finally {

            }
        },
        async handleCheckTabClick() {
            // if(this.dataInitd) return

            if (this.summaryList.length === 0) {
                await this.getSupplierSummaryList(this.basicFormData.id)
            }
            if (this.allSummaryList.length === 0) {
                await this.getAllSummartList(this.basicFormData.id)

            }
            if (this.priceList.length === 0) {
                await this.getPriceList(this.basicFormData.id)
            }

            if (this.currTab === 'comparison') {
                const currRound = this.maxRoundNo
                await this.getListPartCompare(currRound)
            }

            if (!this.dataInitd) {
                this.dataInitd = true
            }

            // this.$nextTick(() => {
            //     if (this.currTab === 'summary') {
            //         this.initSummaryCharts()
            //     } else {
            //         // this.pm.partList.forEach(v => {
            //         //     this.initEcharts(v)
            //         // })
            //     }
            // })

        },

        initSummaryCharts() {
            const data = {
                suppliers: this.summaryList
            }
            const options = new partmodel().getPartEchartsOption(data)
            const myChart = echarts.init(document.getElementById('summaryCharts'))
            myChart.setOption(options)
        },
        selectionSummaryChange(val) {
            // 更新供应商下所有零件 chooseFlag 注意轮次
            this.selectSummaryData = val
            // this.selectPartData = []
        },
        selectionPartChange(val) {
            // 更新零件 chooseFlag 注意轮次
            this.selectPartData = val
            // this.selectSummaryData = []
        },
        getPartData() {
            return this.priceList.filter(part => (part.rfqPartId && part.rfqSupplierId && part.roundNo)).map(part => {
                part.chooseFlag = 0
                const index = this.selectPartData.findIndex(select => select.id === part.id)
                const indexSupplier = this.selectSummaryData.findIndex(select => select.rfqSupplierId === part.rfqSupplierId)
                if (index >= 0 || indexSupplier >= 0) {
                    part.chooseFlag = 1
                }
                return {
                    rfqPartId: part.rfqPartId,
                    rfqSupplierId: part.rfqSupplierId,
                    roundNo: part.roundNo,
                    chooseFlag: part.chooseFlag
                }
            })
        },
        getSupplierData() {
            return this.summaryList.filter(supplier => (supplier.rfqSupplierId)).map(supplier => {
                supplier.chooseFlag = 0
                const indexSupplier = this.selectSummaryData.findIndex(select => select.rfqSupplierId === supplier.rfqSupplierId)
                if (indexSupplier >= 0) {
                    supplier.chooseFlag = 1
                }
                return {
                    id: supplier.rfqSupplierId,
                    chooseFlag: supplier.chooseFlag
                }
            })
        },
        async changeRoundNo(val) {
            this.getSupplierSummaryList(this.basicFormData.id)
            await this.getPriceList(this.basicFormData.id)
            await this.getListPartCompare(val)
        },

        async getListPartCompare(roundNo) {
            try {
                const params = {
                    rfqId: this.basicFormData.id,
                    roundNo: roundNo,
                }
                debugger
                const data = await listPartCompare(params)
                if (data && data.code === '00') {
                    this.partCompareList = data.body
                    debugger
                    if (this.partCompareList.length) {
                        //TODO 有了供应商接口后应该替换掉
                        const suppList = []
                        const fixedKeySet = new Set(['partCode', 'partId', 'partName', 'rfqId', 'targetPrice', 'oneCarCount'])
                        const row = this.partCompareList[0]
                        for (let key in row) {
                            if (!fixedKeySet.has(key)) {
                                //TODO 看看supplierList有没有prop进来, 然后是rfqSupplierId是否是要找的key,是rfqSupplierId还是id
                                var supp = this.supplierList.find(v => String(v.id) === key)
                                if (supp) {
                                    suppList.push({
                                        id: String(supp.id),
                                        name: supp.rfqSupplierName,
                                    })
                                }
                            }
                        }
                        this.currentSupplierList = suppList
                    } else {
                        this.currentSupplierList = []
                    }

                    // this.totalPage = data.body.total
                } else {
                    this.partCompareList = []
                }

            } catch (e) {
                console.log(e)
            } finally {

            }
        },
        handleRoundChange(round) {
            this.getListPartCompare(round)
        },
        handleChange(val) {
            console.log(val, 'val')
            if (val) {
                this.$nextTick(() => {
                    this.pm.partList.forEach(v => {
                        this.initEcharts(v)
                    })
                })
            }
        },
        handleMainChange(val) {
            console.log(val, 'val')
            if (val) {
                this.$nextTick(() => {
                    if (this.currTab === 'summary') {
                        this.initSummaryCharts()
                    }
                })
            }
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            if (String(val).indexOf('.') < 0) {
                return val
            }
            //this.basicFormData.priceBit
            return Number(Number(val).toFixed(3))
        },
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.ml5 {
    margin-left: 5px;
}

.ml10 {
    margin-left: 10px;
}

.mb15 {
    margin-bottom: 15px;
}

.mt20 {
    margin-top: 20px;
}

.mt10 {
    margin-top: 10px;
}

.min-price {
    // color: red;
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
}
</style>
